import React, { ReactNode } from "react";
import "./ProductCard.scss";
import { MotifButton } from "@ey-xd/motif-react";
import { useNavigate } from "react-router";

interface ProductCardProps {
  ProductId: string;
  Name: string;
  Description: string | ReactNode;
  className?: string;
  ButtonName?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  ProductId,
  Name,
  Description,
  className,
  ButtonName,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleCardClick = (e: React.MouseEvent) => {
    if (ProductId === "ai-smart-search" && onClick) {
      onClick(e);
    } else {
      navigate("/product/" + ProductId);
    }
  };

  return (
    <>
      <div className={`product-card${className ? " " + className : ""}`} onClick={handleCardClick}>
        <h3 className="product-card-title">{Name}</h3>
        <div className="product-card-body">
          <div className="product-card-description">{Description}</div>
        </div>
        <div className="product-card-footer">
          <MotifButton
            className={"product-card-btn-estimate" + (ButtonName === "Try Now" ? " try-now" : "")}
            onClick={handleCardClick}
          >
            {ButtonName || "Get Started"}
          </MotifButton>
        </div>
      </div>
    </>
  );
};

export default ProductCard;
